import playnGoImg from '../../../shared/assets/images/playn-go.jpg';
import club888Img from '../../../shared/assets/images/club-888.jpg';
import greenDreamImg from '../../../shared/assets/images/green-dream.jpg';
import ptcImg from '../../../shared/assets/images/ptc.jpg';
import ppLiveCasinoImg from '../../../shared/assets/images/pp-live-casino.jpg';
import onlyPlayImg from '../../../shared/assets/images/only-play.png';
import fafiImg from '../../../shared/assets/images/fafi.jpg';
import rlnImg from '../../../shared/assets/images/rln.jpg';
import visoGamesImg from '../../../shared/assets/images/viso-games.jpg';
import netEntImg from '../../../shared/assets/images/netenttemp.jpg';
import olnImg from '../../../shared/assets/images/oln.jpg';
import crashGamesImg from '../../../shared/assets/images/crash-games.png';
import gnsImg from '../../../shared/assets/images/gns.png';

export const PRODUCTS = {
  playnGo: {
    name: "Play'n GO",
    id: 'playn-go',
    img: {
      path: playnGoImg,
      width: '402',
      height: '230',
    },
  },
  club888: {
    name: 'CLUB 888',
    id: 'club-888',
    img: {
      path: club888Img,
      width: '402',
      height: '230',
    },
  },
  greenDream: {
    name: 'Green Dream',
    id: 'green-dream',
    img: {
      path: greenDreamImg,
      width: '402',
      height: '230',
    },
  },
  ptc: {
    name: 'Palm Treasures Club',
    id: 'ptc',
    img: {
      path: ptcImg,
      width: '402',
      height: '230',
    },
  },
  onlyPlay: {
    name: 'Only Play',
    id: 'only-play',
    img: {
      path: onlyPlayImg,
      width: '402',
      height: '230',
    },
  },
  visoGames: {
    name: 'VisoGames',
    id: 'viso-games',
    img: {
      path: visoGamesImg,
      width: '402',
      height: '230',
    },
  },
  netEnt: {
    name: 'NetEnt',
    id: 'net-ent',
    img: {
      path: netEntImg,
      width: '402',
      height: '230',
    },
  },
  ppLiveCasino: {
    name: 'Pragmatic Play Live Casino',
    id: 'pp-live-casino',
    img: {
      path: ppLiveCasinoImg,
      width: '402',
      height: '230',
    },
  },
  fafi: {
    name: 'Fafi',
    id: 'fafi',
    img: {
      path: fafiImg,
      width: '402',
      height: '230',
    },
  },
  rln: {
    name: 'Rapid Lucky Numbers',
    id: 'rln',
    img: {
      path: rlnImg,
      width: '402',
      height: '230',
    },
  },
  oln: {
    name: 'Online Lucky Numbers',
    id: 'oln',
    img: {
      path: olnImg,
      width: '402',
      height: '230',
    },
  },
  lns: {
    name: 'Online Lucky Numbers',
    id: 'lns',
    img: {
      path: olnImg,
      width: '402',
      height: '230',
    },
  },
  crashGames: {
    name: 'Crash Games',
    id: 'crash-games',
    img: {
      path: crashGamesImg,
      width: '402',
      height: '230',
    },
  },
  gns: {
    name: 'GNS',
    id: 'gns',
    img: {
      path: gnsImg,
      width: '402',
      height: '230',
    },
  },
};

const toThreshold = (value) => (typeof value === 'number' ? value : null);

export const parseUnitParams = (params) => {
  const unit = params.unit;
  if (!unit) {
    throw new Error('error');
  }
  if (unit.site && !unit.site.active) {
    throw new Error('site_not_active');
  }

  let gamesConfigs = {};
  if (params.games) {
    gamesConfigs = getGamesConfigs(params.games, params.productSlugs);
  }

  const unitConfigs = {
    id: unit.id,
    siteId: unit.site?.id,
    balance: unit.fin_account.balance,
    bonus: unit.fin_account.bonus_balance,
    depositBalance: unit.fin_account.deposit_balance || 0,
    allowedPaymentMethods: Array.isArray(unit.allowed_payment_methods)
      ? unit.allowed_payment_methods
      : [],
    ...gamesConfigs,
  };

  // NOTE: Only set when sent, so unit updates without it keep the current value
  if (unit.active_campaign_bonus_balance !== undefined) {
    unitConfigs.activeCampaignBonusBalance =
      unit.active_campaign_bonus_balance || 0;
  }

  if (unit.config) {
    unitConfigs.registrationRequiredForDeposit =
      unit.config.registration_required_for_deposit;
    unitConfigs.cashoutAtmMinAmount = unit.config.im_withdrawal_min_amount;
    unitConfigs.cashoutEftMinAmount = unit.config.eft_withdrawal_min_amount;
    unitConfigs.cashoutAtmFee = unit.config.im_withdrawal_fee;
    unitConfigs.cashoutEftFee = unit.config.eft_withdrawal_fee;
    unitConfigs.cashoutFreeRequestsNum = unit.config.free_bank_withdrawal_count;
    unitConfigs.cashoutRequestFeePeriod =
      unit.config.bank_withdrawal_fee_period;
    unitConfigs.supportParams = {
      useChat: !!unit.config.chat_enabled,
      accountId: unit.config.chat_account_id,
      whatsapp: unit.config.whatsapp_phone,
    };
    unitConfigs.secondLevelVerificationThreshold = toThreshold(
      unit.config.second_level_verification_threshold
    );
    unitConfigs.thirdLevelVerificationThreshold = toThreshold(
      unit.config.third_level_verification_threshold
    );
    unitConfigs.monthlySecondLevelVerificationThreshold = toThreshold(
      unit.config.monthly_second_level_verification_threshold
    );
    unitConfigs.monthlyThirdLevelVerificationThreshold = toThreshold(
      unit.config.monthly_third_level_verification_threshold
    );
  }

  const allowed = Array.isArray(unitConfigs.allowedPaymentMethods)
    ? unitConfigs.allowedPaymentMethods
    : [];
  unitConfigs.showAcoinLink =
    allowed.includes('acoin') || allowed.includes('acoin_phone');
  unitConfigs.cashoutAtmEnabled = allowed.includes('im_withdrawal');
  unitConfigs.cashoutEftEnabled = allowed.includes('eft_withdrawal');
  unitConfigs.cashoutTicketEnabled = allowed.includes('ticket_cash_out');

  if (unit.jackpots) {
    unitConfigs.jackpots = {
      enabled: unit.jackpots.enabled || false,
      mini: unit.jackpots.mini_amount || 0,
      major: unit.jackpots.major_amount || 0,
      mega: unit.jackpots.mega_amount || 0,
      rules: unit.jackpots.rules || {},
    };
  }

  return unitConfigs;
};

const handleBlockageError = (message) => {
  let blockageMessage;
  let blockageRedirect;

  if (message === 'Deposit block') {
    blockageMessage =
      'Your account is blocked. Please contact Support Team for further details.';
  }
  if (message === 'Withdrawal block') {
    blockageMessage =
      'Withdrawals are currently blocked on your account. Please contact the Support Team for further details.';
  }
  if (message === 'Open game block') {
    blockageMessage =
      'Your access to games is currently blocked. Please contact the Support Team for assistance.';
    blockageRedirect = window.location.origin;
  }

  return {
    blockageMessage,
    blockageRedirect,
  };
};

export const handleError = (error, redirect) => {
  let errorMessage;
  let errorRedirect = redirect;
  let additionalInfo = null;

  const errorResponseData = error.response?.data?.error;

  if (errorResponseData) {
    if (errorResponseData.code === 'unit:block') {
      const { blockageMessage, blockageRedirect } = handleBlockageError(
        errorResponseData.msg
      );
      errorMessage = blockageMessage;
      errorRedirect = blockageRedirect;
    } else {
      switch (error.response.data.error.code) {
        case 'units_ctx:sites:not_found':
          errorMessage =
            'The site name you have entered is not found. Please check and re-enter.';
          errorRedirect = '/';
          break;
        case 'api_client:acoin:invalid_merchant_token':
          errorMessage = `This voucher cannot be used on this site. Contact ${process.env.REACT_APP_NAME} support for assistance.`;
          break;
        case 'api_client:acoin:invalid_voucher':
          errorMessage = 'Invalid Voucher';
          break;
        case 'api_client:acoin:voucher_redeemed':
          errorMessage = 'Voucher has already been used.';
          break;
        case 'api_client:acoin:server':
          errorMessage = `Something wrong. Contact ${process.env.REACT_APP_NAME} support for assistance.`;
          if (
            error.response.data.error.msg ===
            'aCoin error [400]: Invalid phone number [400]'
          ) {
            additionalInfo = 'Invalid phone number';
          } else {
            additionalInfo = error.response.data.error.msg;
          }
          break;
        case 'fin_ctx:fin_ops:no_funds':
          errorMessage = 'No funds available to cash out.';
          break;
        case 'units_ctx:sites:not_active':
          errorMessage = 'This site is not active now.';
          errorRedirect = '/';
          break;
        case 'units_ctx:games:not_found':
          errorMessage = 'Game not found.';
          break;
        case 'api_client:game_server:processing':
          if (
            error.response.data.error.msg === '7R Game Server error: Not Active'
          ) {
            errorMessage = 'Ticket is not active';
          } else if (
            error.response.data.error.msg ===
            '7R Game Server error: Owner Id mismatch'
          ) {
            errorMessage = 'Ticket Access Denied';
            additionalInfo =
              'This ticket has been cashed out by another user. Please note that a ticket can only be loaded by the user who originally cashed it out from their account.';
          } else if (
            error.response.data.error.msg.includes('Ticket not Found barcode')
          ) {
            errorMessage = 'Invalid Voucher';
          } else {
            errorMessage = error.response.data.error.msg.replace(
              '7R Game Server error: ',
              ''
            );
          }
          break;
        case 'users_ctx:kyc:kyc_verification_reach_max_attemtps':
          errorMessage =
            'You have exceeded the maximum number of verification attempts. Please contact support for assistance.';
          break;
        case 'users_ctx:kyc:kyc_verification_already_in_progress':
          errorMessage = 'Verification is in progress.';
          break;
        case 'users_ctx:users:login_block':
          errorMessage =
            'Your account is blocked. Please contact Support Team for further details.';
          break;
        case 'users_ctx:users:validation:phone:not_unique':
          errorMessage = 'This phone number is already in use';
          break;
        case 'users_ctx:kyc:required_level:invalid':
          errorMessage = 'Error, please try again.';
          break;
        case 'users_ctx:kyc:provider_not_found':
          errorMessage = 'Error, please contact support.';
          break;
        case 'users_ctx:idp:api_key_not_found':
          errorMessage = 'Error, please contact support.';
          break;
        case 'api_client:idp:parse:migration_documents_missing':
          errorMessage = 'Error, please contact support.';
          break;
        case 'api_client:idp:parse':
          errorMessage = 'Error, please contact support.';
          break;
        case 'api_client:idp:request_encoding':
          errorMessage = 'Error, please try again with the correct document.';
          break;
        case 'api_client:idp:connection':
          errorMessage = 'Connection error, please try again later.';
          break;

        case 'users_ctx:player_bank_accounts:validation:number:not_unique':
        case 'fin_ctx:eft_withdrawals:validation:bank_account_number:not_unique':
          errorMessage =
            'This bank account is already linked to another profile and cannot be used for this withdrawal.';
          additionalInfo =
            'Please contact Support if you believe this is an error.';
          break;

        default:
          errorMessage = error.response.data.error.msg;
      }
    }
  } else if (error.data && error.data.errorCode) {
    switch (error.data.errorCode) {
      case 101:
        errorMessage =
          'The site name you have entered is not found. Please check and re-enter.';
        errorRedirect = '/';
        break;
      default:
        errorMessage = error.data.message;
    }
  } else if (error.message) {
    switch (error.message) {
      case 'site_not_active':
        errorMessage = 'This site is not active now';
        errorRedirect = '/';
        break;
      case 'ticket_not_support':
        errorMessage = 'This site does not support load funds by Ticket';
        errorRedirect = '/';
        break;
      case 'auth:wrong_password':
        errorMessage = 'Wrong password.';
        break;
      default:
        // When a maintenance page component is needed
        if (error.code && error.code === 'ERR_NETWORK') {
          if (navigator.onLine) {
            errorMessage = 'Maintenance';
            additionalInfo = 'server_offline';
          } else {
            errorMessage = 'Network connection error';
          }
        } else {
          errorMessage = 'An unknown error occurred.';
          additionalInfo = error.message;
        }

      // When a maintenance page component is not needed
      // errorMessage = 'An unknown error occurred.';
      // additionalInfo = error.message;
    }
  } else {
    errorMessage = 'An unknown error occurred!';
  }

  return { message: errorMessage, redirect: errorRedirect, additionalInfo };
};

const getGamesConfigs = (games, productSlugs = []) => {
  const gamesConfigs = { products: [] };
  const hasLns = productSlugs.includes(PRODUCTS.lns.id);

  if (games.popular) {
    gamesConfigs.topGames = games.popular.map((game) =>
      parseGameParams(game, { type: '-top.png', width: '248', height: '165' })
    );
  }

  if (games.ptc && games.ptc.length) {
    gamesConfigs.products.push(PRODUCTS.ptc);
    gamesConfigs.ptcGames = games.ptc.map((game) =>
      parseGameParams(
        game,
        { type: '.png', width: '160', height: '114' },
        PRODUCTS.ptc.id
      )
    );
  }

  if (games['crash-games'] && games['crash-games'].length) {
    gamesConfigs.products.push(PRODUCTS.crashGames);
    gamesConfigs.crashGames = games['crash-games'].map((game) =>
      parseGameParams(
        game,
        { type: '.png', width: '300', height: '200' },
        PRODUCTS.crashGames.id
      )
    );
  }

  if (games.club888 && games.club888.length) {
    gamesConfigs.products.push(PRODUCTS.club888);
    gamesConfigs.club888Games = games.club888.map((game) =>
      parseGameParams(
        game,
        { type: '.jpg', width: '301', height: '180' },
        PRODUCTS.club888.id
      )
    );
  }

  if (games.greendream && games.greendream.length) {
    gamesConfigs.products.push(PRODUCTS.greenDream);
    gamesConfigs.greenDreamGames = games.greendream.map((game) =>
      parseGameParams(
        game,
        { type: '.jpg', width: '301', height: '180' },
        PRODUCTS.greenDream.id
      )
    );
  }

  if (games.png && games.png.length) {
    gamesConfigs.products.push(PRODUCTS.playnGo);
    gamesConfigs.playnGoGames = games.png.map((game) =>
      parseGameParams(
        game,
        { type: '.jpg', width: '301', height: '180' },
        PRODUCTS.playnGo.id
      )
    );
  }

  if (games.op && games.op.length) {
    gamesConfigs.products.push(PRODUCTS.onlyPlay);
    gamesConfigs.onlyPlayGames = games.op.map((game) =>
      parseGameParams(
        game,
        { type: '.jpg', width: '301', height: '180' },
        PRODUCTS.onlyPlay.id
      )
    );
  }

  if (games['pp-lg'] && games['pp-lg'].length) {
    gamesConfigs.products.push(PRODUCTS.ppLiveCasino);
    gamesConfigs.ppLiveCasinoGames = games['pp-lg'].map((game) => ({
      id: game.vendor_data.gameID,
      slug: game.slug,
      productId: PRODUCTS.ppLiveCasino.id,
      name: game.name,
    }));
  }

  if (games.fafi && games.fafi.length) {
    gamesConfigs.products.push(PRODUCTS.fafi);
  }

  if (games.viso && games.viso.length) {
    gamesConfigs.products.push(PRODUCTS.visoGames);
    gamesConfigs.visoGames = games.viso.map((game) =>
      parseGameParams(
        game,
        { type: '.png', width: '300', height: '200' },
        PRODUCTS.visoGames.id
      )
    );
  }

  if (games.gns && games.gns.length) {
    gamesConfigs.products.push(PRODUCTS.gns);
    gamesConfigs.gnsGames = games.gns.map((game) =>
      parseGameParams(
        game,
        { type: '.png', width: '300', height: '200' },
        PRODUCTS.gns.id
      )
    );
  }

  if (games.netent && games.netent.length) {
    gamesConfigs.products.push(PRODUCTS.netEnt);
    gamesConfigs.netEntGames = games.netent.map((game) =>
      parseGameParams(
        game,
        { type: '.jpg', width: '301', height: '180' },
        PRODUCTS.netEnt.id
      )
    );
  }

  if (games.rln && games.rln.length) {
    gamesConfigs.products.push(PRODUCTS.rln);
  }

  if (!hasLns && games.oln && games.oln.length) {
    gamesConfigs.products.push(PRODUCTS.oln);
    gamesConfigs.olnGames = games.oln.map((game) =>
      parseGameParams(
        game,
        { type: '.png', width: '264', height: '158' },
        PRODUCTS.oln.id
      )
    );
  }

  if (hasLns) {
    gamesConfigs.products.push(PRODUCTS.lns);
  }

  if (games['popular-lotto']) {
    gamesConfigs.topOlnGames = games['popular-lotto'].map((game) =>
      parseGameParams(
        game,
        { type: '.png', width: '264', height: '158' },
        PRODUCTS.oln.id
      )
    );
  }

  if (games.bonus) {
    gamesConfigs.bonusGames = games.bonus.map((game) => parseGameParams(game));
  }

  return gamesConfigs;
};

const getGameImgParams = (productId) => {
  switch (productId) {
    case PRODUCTS.ptc.id:
      return { type: '.png', width: '160', height: '114' };

    case PRODUCTS.visoGames.id:
    case PRODUCTS.crashGames.id:
    case PRODUCTS.gns.id:
      return { type: '.png', width: '300', height: '200' };

    default:
      return { type: '.jpg', width: '301', height: '180' };
  }
};

const parseGameParams = (game, imgParams, productId) => {
  let gameProductId;
  let gameImgParams = imgParams;

  if (productId) {
    gameProductId = productId;
  } else {
    gameProductId = parseGameProductId(game.vendor);
    if (!gameImgParams) {
      gameImgParams = getGameImgParams(gameProductId);
    }
  }

  return {
    slug: game.slug,
    productId: gameProductId,
    name: game.name,
    img: {
      path: `/static/media/${game.slug.replace(/_/g, '-')}${gameImgParams.type}`,
      width: gameImgParams.width,
      height: gameImgParams.height,
    },
    isNew: !!game.tags.find((tag) => tag.slug === 'new'),
    hasBonus: !!game.tags.find((tag) => tag.slug === 'bonus'),
    hasJackpot: !!game.tags.find((tag) => tag.slug === 'jackpot'),
    isTop: !!game.tags.find((tag) => tag.slug === 'popular-lotto'),
    jackpotMode: game.jackpot_mode || 'disabled',
  };
};

const parseGameProductId = (gameVendor) => {
  switch (gameVendor) {
    case '7r:spribe':
    case '7r:inout':
      return PRODUCTS.crashGames.id;

    case '7r:png':
      return PRODUCTS.playnGo.id;

    case '7r:amatic':
      return PRODUCTS.ptc.id;

    case 'gmw':
      return PRODUCTS.club888.id;

    case '7r:novomatic':
      return PRODUCTS.greenDream.id;

    case 'vx':
      return PRODUCTS.visoGames.id;

    case '7r:nt':
      return PRODUCTS.netEnt.id;

    case 'pp:lg':
      return PRODUCTS.ppLiveCasino.id;

    case '7r:fafi':
      return PRODUCTS.fafi.id;

    case '7r:rln':
      return PRODUCTS.rln.id;

    case 'op':
      return PRODUCTS.onlyPlay.id;

    case '7r:oln':
      return PRODUCTS.oln.id;

    case 'lns':
      return PRODUCTS.lns.id;

    case 'gns':
      return PRODUCTS.gns.id;
  }
};
